
import React, { useState, useEffect, useRef } from 'react';
import './CommunityDropdown.scss';

const CommunityDropdown = ({
  data,
  onSelect,
  defaultSelection,
  alwaysShowDefaultSelection
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [haveText, setHaveText] = useState(defaultSelection || 'All');
  const modalRef = useRef(null);
  const modalPlaceholderRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // const { current } = modalRef;
      const { current: placeHolderCurrent } = modalPlaceholderRef;

      if (!placeHolderCurrent.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [])

  const handleClick = () => setIsOpen(!isOpen);

  const handleText = (ev) => {
    if(!alwaysShowDefaultSelection) setHaveText(ev.currentTarget.textContent);
    onSelect(ev.currentTarget.textContent);
  };

  const itemList = props => {
    const list = props.map((item, idx) => (
      <div
        onClick={handleText}
        className="community_dropdown__item"
        key={item ? `${item.toString()}-${idx}`: `${idx}`}
        ref={modalRef}
      >
        {item}
      </div>
    ));

    return (
      <div className="community_dropdown__items">
        { list}
      </div>
    )
  }

  return (
    <div
      className={isOpen ? "community_dropdown active" : "community_dropdown"}
      onClick={handleClick} ref={modalPlaceholderRef}>
      <div className="community_dropdown__text">
        {haveText}
      </div>
      {itemList(data)}
    </div>
  );
}

export default CommunityDropdown;
